import { API_APPOINTMENT, API_CONSULT, API_EMC } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getPatientInfo(patientId) {
  return {
    types: [
      ACTION_TYPES.PATIENT_GET_REQUESTED,
      ACTION_TYPES.PATIENT_GET_SUCCEED,
      ACTION_TYPES.PATIENT_GET_FAILED,
    ],
    promise: client => client.get(`/v1.3/patients/${patientId}`),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function searchPatient({ search, scope }) {
  return {
    types: [
      ACTION_TYPES.PATIENT_SEARCH_REQUESTED,
      ACTION_TYPES.PATIENT_SEARCH_SUCCEED,
      ACTION_TYPES.PATIENT_SEARCH_FAILED,
    ],
    promise: client =>
      client.get('/v1.3/doctors/me/patients/search', {
        params: { pageSize: 20, term: search, scope },
      }),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}
export function searchClinicPatient({ search }) {
  return {
    types: [
      ACTION_TYPES.CLINIC_PATIENT_SEARCH_REQUESTED,
      ACTION_TYPES.CLINIC_PATIENT_SEARCH_SUCCEED,
      ACTION_TYPES.CLINIC_PATIENT_SEARCH_FAILED,
    ],
    promise: client =>
      client.get('/v1.4/clinics/patients', {
        params: { page: 1, pageSize: 100, term: search },
      }),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function createPatient(body) {
  return {
    types: [
      ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_REQUESTED,
      ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_SUCCEED,
      ACTION_TYPES.APPOINTMENT_PATIENT_CREATE_FAILED,
    ],
    promise: client => client.post(`/v1.4/clinics/patients`, body),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function getRecentMCs(patientId, params) {
  return {
    types: [
      ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_REQUESTED,
      ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_SUCCEED,
      ACTION_TYPES.PATIENT_GET_LAST_30_DAYS_MC_FAILED,
    ],
    promise: client => client.get(`/certificates/history?patient_id=${patientId}`, { params }),
    options: {
      clientName: API_EMC,
    },
  };
}

export function getRecentReasons(patientId, params) {
  return {
    types: [
      ACTION_TYPES.PATIENT_GET_RECENT_REASON_REQUESTED,
      ACTION_TYPES.PATIENT_GET_RECENT_REASON_SUCCEED,
      ACTION_TYPES.PATIENT_GET_RECENT_REASON_FAILED,
    ],
    promise: client => client.get(`/patients/${patientId}/last-consult-reasons`, { params }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function countRecentMCs(patientId, clinicId, consultServiceId = '') {
  return {
    types: [
      ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_REQUESTED,
      ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_SUCCEED,
      ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_FAILED,
    ],
    promise: client =>
      client.get(`/certificates/count`, { params: { patientId, clinicId, consultServiceId } }),
    options: {
      clientName: API_EMC,
    },
  };
}

export function resetCountRecentMCs() {
  return {
    type: ACTION_TYPES.PATIENT_COUNT_LAST_30_DAYS_MC_RESET,
  };
}

export function resetRecentReason() {
  return {
    type: ACTION_TYPES.PATIENT_GET_RECENT_REASON_RESET,
  };
}
